// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入全部组件
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// iView
import iView from 'iview'
import 'iview/dist/styles/iview.css'

// vant 组件
import Vant from 'vant'
import { Toast } from 'vant'
import 'vant/lib/index.css'

// 引入vue - Swiper
import VueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/css/rest.css'
import 'lib-flexible/flexible'
// 引入Swiper
// import Swiper from 'swiper'
// import 'swiper/dist/css/swiper.css'

// axios
// import axios from 'axios'
import axios from './utils/axios.interceptor'
import VueAxios from 'vue-axios'

// 设置微信 title
import WechatTitle from 'vue-wechat-title'

// import Utils from "utils.js"
import Utils from '../src/utils/utils.js'

import '../src/components/css/style.css'
import '../src/components/css/css.css'

// 设置参数 序列化
import qs from 'qs'

// 微信分享
// import wx from 'weixin-js-sdk'
// import './wx/weixin.js'
import wxShare from '../src/wx/weixin.js'

// 图标
import eCharts from 'echarts'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 截屏图片
import html2canvas from 'html2canvas'
import canvg from 'canvg'
import YSF from '@neysf/qiyu-web-sdk'
import store from './store'
import bus from './utils/eventbus'

Vue.use(ElementUI)
Vue.use(MintUI)
Vue.use(iView)
Vue.use(Vant)
Vue.prototype.Toast = Toast
Vue.use(VueSwiper)
Vue.prototype.axios = axios
Vue.use(VueAxios, axios)
Vue.use(WechatTitle)
Vue.prototype.utils = Utils
Vue.prototype.QS = qs
Vue.prototype.wxShare = wxShare
Vue.prototype.echarts = eCharts
Vue.prototype.html2canvas = html2canvas
Vue.prototype.canvg = canvg
Vue.prototype.YSF = YSF
window.eventBus = new Vue()

Vue.prototype.bus = bus

Vue.prototype.accountUrl = '/account'
Vue.prototype.companyUrl = Utils.envUrl == 'pro' ? '/company' : '/pindex'
// 引入微信调试工具 vconsole 生产需要去掉
// import vConsole from "./utils/vconsole"
// Vue.use(vConsole)

// Vue.prototype.newPayUrl = '/newPay'
Vue.prototype.appIdPay = 'wxf577354cade27a13' // 微信支付平台  支付用的
Vue.prototype.appIdMall =
  Utils.envUrl == 'pro' ? 'wxa8b856ad27422ea1' : 'wxd3d0fd9e7b892012' // 微信中消商城公众号appId

// 动态配置测试 or 正式环境url
Vue.prototype.static_url =
  Utils.envUrl == 'pro'
    ? 'https://m.zxzx119.com/'
    : 'http://192.168.166.74:8081/#/' // 'http://192.168.166.74:8081/#/'
// 跳转pc 订单列表
Vue.prototype.pcOrderList =
  Utils.envUrl == 'pro'
    ? 'http://personal.zxzx119.com/home/orderList'
    : 'http://192.168.166.74:8081/home/orderList' // 'http://192.168.166.74:8081/home/orderList'

// Vue.prototype.businessID = 26114

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  console.log('to:' + to.path + ';from:' + from.path)
  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
Vue.prototype._isMobile = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag
}
Vue.prototype.isEmpty = function (value) {
  // 判断一个变量是否为空值 isEmpty()
  // [],{},'',' ',null,undefined,NaN都返回为true
  value = typeof value === 'string' ? value.replace(/\s/g, '') : value // 去掉空格判断
  value = value == 0 ? String(value) : value // 如果数字0变成字符串判断
  if (value) {
    return (
      (Array.isArray(value) && value.length === 0) ||
      (Object.prototype.isPrototypeOf(value) && Object.keys(value).length === 0)
    )
  } else {
    return true
  }
}
Vue.prototype.money_dot = function (money) {
  if (money) {
    if (isNaN(money)) {
      alert('金额中含有不能识别的字符')
      return
    }
    money = typeof money === 'string' ? parseFloat(money) : money // 判断是否是字符串如果是字符串转成数字
    money = (money / 100).toFixed(2) // 保留两位
    money = parseFloat(money) // 转成数字
    money = money.toLocaleString() // 转成金额显示模式
    // 判断是否有小数
    if (money.indexOf('.') === -1) {
      money = money + '.00'
    } else {
      money = money.split('.')[1].length < 2 ? money + '0' : money
    }
    return money // 返回的是字符串23,245.12保留2位小数
  } else {
    return (money = null)
  }
}

// 清除所有cookie
Vue.prototype.delAllCookie = function () {
  var keys = document.cookie.match(/[^ =;]+(?==)/g)
  console.log(keys)
  if (keys) {
    for (var i = keys.length; i--;) {
      document.cookie =
        keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
      document.cookie =
        keys[i] +
        '=0;path=/;domain=' +
        document.domain +
        ';expires=' +
        new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
      document.cookie =
        keys[i] +
        '=0;path=/;domain=ratingdog.cn;expires=' +
        new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.js